<div id="layout-wrapper">
    <!-- Top Bar -->
    <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()" (settingsButtonClicked)="onSettingsButtonClicked()">
    </app-topbar>

    <!-- Overlay móvil: toca fuera para cerrar el menú -->
    <div class="sidebar-overlay" (click)="closeSidebar()"></div>

    <!-- Botón X para cerrar el menú en móvil -->
    <button class="sidebar-close-btn" (click)="closeSidebar()" aria-label="Cerrar menú">&times;</button>

    <app-sidebar></app-sidebar>
    <div class="main-content" id="mainContent">
        <div class="page-content">
            <div class="container-fluid">
                <!-- content -->
                <router-outlet></router-outlet>
            </div>
        </div>
        <!-- footer -->
        <app-footer></app-footer>
    </div>
</div>
<app-rightsidebar></app-rightsidebar>